import logger from "redux-logger";

export const FETCH_SUPPORTTYPE_INIT_ACTION =
  "FETCH_SUPPORTTYPE_INIT_ACTION";
export const FETCH_SUPPORTTYPE_SUCCESS_ACTION =
  FETCH_SUPPORTTYPE_INIT_ACTION + "_SUCCESS";
export const FETCH_SUPPORTTYPE_FAIL_ACTION =
  FETCH_SUPPORTTYPE_INIT_ACTION + "_ERROR";

  export const EDIT_SUPPORT_INIT_ACTION =
  "EDIT_SUPPORT_INIT_ACTION";
export const EDIT_SUPPORT_SUCCESS_ACTION =
  EDIT_SUPPORT_INIT_ACTION + "_SUCCESS";
export const EDIT_SUPPORT_FAIL_ACTION =
EDIT_SUPPORT_INIT_ACTION + "_ERROR";

export const ADD_SUPPORTHISTORY_INIT_ACTION =
"ADD_SUPPORTHISTORY_INIT_ACTION";
export const ADD_SUPPORTHISTORY_SUCCESS_ACTION =
ADD_SUPPORTHISTORY_INIT_ACTION + "_SUCCESS";
export const ADD_SUPPORTHISTORY_FAIL_ACTION =
ADD_SUPPORTHISTORY_INIT_ACTION + "_ERROR";

export const FETCH_SUPPORTUSERS_INIT_ACTION =
"FETCH_SUPPORTUSERS_INIT_ACTION";
export const FETCH_SUPPORTUSERS_SUCCESS_ACTION =
FETCH_SUPPORTUSERS_INIT_ACTION + "_SUCCESS";
export const FETCH_SUPPORTUSERS_FAIL_ACTION =
FETCH_SUPPORTUSERS_INIT_ACTION + "_ERROR";

export const FETCH_SUPPORTDETAILS_INIT_ACTION =
  "FETCH_SUPPORTDETAILS_INIT_ACTION";
export const FETCH_SUPPORTDETAILS_SUCCESS_ACTION =
  FETCH_SUPPORTDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_SUPPORTDETAILS_FAIL_ACTION =
  FETCH_SUPPORTDETAILS_INIT_ACTION + "_ERROR";

export const FETCH_SUPPORTHISTORY_INIT_ACTION =
  "FETCH_SUPPORTHISTORY_INIT_ACTION";
export const FETCH_SUPPORTHISTORY_SUCCESS_ACTION =
  FETCH_SUPPORTHISTORY_INIT_ACTION + "_SUCCESS";
export const FETCH_SUPPORTHISTORY_FAIL_ACTION =
  FETCH_SUPPORTHISTORY_INIT_ACTION + "_ERROR";

export function fetchSupportType() {
  return {
    type: FETCH_SUPPORTTYPE_INIT_ACTION,
  };
}

export function supportList(value) {
  return {
    type: FETCH_SUPPORTDETAILS_INIT_ACTION,
    value:value
  };
}

export function SupportSelectedPage(value) {
  return {
    type: FETCH_SUPPORTDETAILS_INIT_ACTION,
    value: value
  };
}

export function SupportHistorySelectedPage(value) {
  return {
    type: FETCH_SUPPORTHISTORY_INIT_ACTION,
    value: value
  };
}

export function editSupport(value) {
  return {
    type: EDIT_SUPPORT_INIT_ACTION,
    value: value
  };
}

export function addSupportHistory(value) {
  return {
    type: ADD_SUPPORTHISTORY_INIT_ACTION,
    value: value
  };
}

export function fetchSupportHistory(value) {
  return {
    type: FETCH_SUPPORTHISTORY_INIT_ACTION,
    value: value
  };
}

export function fetchSupportUsers() {
  return {
    type: FETCH_SUPPORTUSERS_INIT_ACTION,
  };
}